import UploadCustomWatchlistPage from './UploadCustomWatchlistPage';

export default UploadCustomWatchlistPage;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/pages/upload-custom-watchlist-page/index.js